// Salvataggio di un PDF ricevuto come blob (le rotte del PDF richiedono il token:
// un link semplice non lo porterebbe) e lettura del messaggio d'errore, che con
// `responseType: 'blob'` arriva anch'esso come blob JSON.

/** `Verbale - <nome>.pdf`, senza i caratteri vietati nei nomi di file e senza spazi ripetuti. */
export function nomeFilePdfVerbale(nomeEvento: string): string {
  const pulito = (nomeEvento || '')
    .replace(/[\\/:*?"<>|]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return `Verbale - ${pulito || 'evento'}.pdf`;
}

/** Salva il blob con un link temporaneo `<a download>`; l'object URL si revoca dopo 60 secondi. */
export function salvaPdf(blob: Blob, nomeFile: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = nomeFile;
  link.rel = 'noopener';
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    // Revoca differita: alcuni browser avviano il download dopo il clic
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  }
}

const leggiTestoBlob = (blob: Blob): Promise<string> => {
  if (typeof (blob as any).text === 'function') return (blob as any).text();
  return new Promise((resolve, reject) => {
    const lettore = new FileReader();
    lettore.onload = () => resolve(String(lettore.result || ''));
    lettore.onerror = () => reject(lettore.error);
    lettore.readAsText(blob);
  });
};

const messaggioDa = (dati: any): string | null => {
  if (!dati || typeof dati !== 'object') return null;
  if (typeof dati.message === 'string' && dati.message.trim()) return dati.message;
  if (typeof dati.error === 'string' && dati.error.trim()) return dati.error;
  return null;
};

/** Messaggio d'errore della risposta (blob JSON o oggetto: `message`, poi `error`), altrimenti `predefinito`. */
export async function messaggioErrorePdf(err: unknown, predefinito: string): Promise<string> {
  const dati = (err as any)?.response?.data;
  try {
    if (typeof Blob !== 'undefined' && dati instanceof Blob) {
      return messaggioDa(JSON.parse(await leggiTestoBlob(dati))) || predefinito;
    }
    if (typeof dati === 'string') {
      return messaggioDa(JSON.parse(dati)) || predefinito;
    }
    return messaggioDa(dati) || predefinito;
  } catch {
    return predefinito;
  }
}
